<template>
  <div
    class="mr-auto"
    :class="vertical ? 'flex-wrap' : 'd-flex'"
  >
    <b-form-select
      v-model="selectedCategory"
      :disabled="disableLevel > 0"
      :class="vertical ? 'mb-3' : 'mr-3'"
      @change="setCategory"
    >
      <template slot="first">
        <b-form-select-option :value="undefined">
          -- {{ $t('product.categories.single') }} --
        </b-form-select-option>
      </template>
      <b-form-select-option
        v-for="category in categories"
        :key="category.id"
        :value="category.id"
      >
        {{ $l(category.title) }}
      </b-form-select-option>
    </b-form-select>
    <b-form-select
      v-model="selectedSub"
      :disabled="disableLevel > 1"
      :class="vertical ? 'mb-3' : 'mr-3'"
    >
      <template slot="first">
        <b-form-select-option :value="undefined">
          -- {{ $t('product.subcategory') }} --
        </b-form-select-option>
      </template>
      <b-form-select-option
        v-for="subCategory in subCategories"
        :key="subCategory.id"
        :value="subCategory.id"
      >
        {{ $l(subCategory.title) }}
      </b-form-select-option>
    </b-form-select>
    <a-select
      style="width: 100%"
      :class="vertical ? 'mb-3' : 'mr-3'"
      mode="multiple"
      :value="selectedSections"
      :disabled="disableLevel > 2"
      placeholder="Sections"
      @change="setSection"
    >
      <a-select-option
        v-for="section in sections"
        :key="section.id"
        :value="section.id"
      >
        {{ $l(section.title) }}
      </a-select-option>
    </a-select>
  </div>
</template>

<script>
import adminService from '@/services/api/admin/library/product-lib-service'
import sellerService from '@/services/api/manager/product-service'
import { mapGetters } from 'vuex'

export default {
  name: 'MultipleSectionSelector',
  props: {
    initialSecs: {
      type: Array,
      default () {
        return []
      },
    },
    initialCat: {
      type: Number,
      default() {
        return undefined
      },
    },
    initialSub: {
      type: Number,
      default() {
        return undefined
      },
    },
    disableLevel: {
      type: Number,
      default () {
        return 0
      },
    },
    vertical: {
      type: Boolean,
      default () {
        return false
      },
    },
  },
  computed: {
    categories () {
      return Object.values(this.mappedCategories)
    },
    subCategories () {
      if (this.selectedCategory != null && this.mappedCategories[this.selectedCategory])
        return Object.values(this.mappedCategories[this.selectedCategory].subCategories)
      else return []
    },
    sections () {
      if (this.selectedSub && this.mappedCategories[this.selectedCategory] && this.mappedCategories[this.selectedCategory].subCategories[this.selectedSub]) {
        const sections = Object.values(this.mappedCategories[this.selectedCategory].subCategories[this.selectedSub].sections)
        return sections.filter(sec => !this.sectionsSet.has(sec.id)).concat(this.presetSections)
      } else {
        return this.presetSections
      }
    },
    ...mapGetters({
      role: 'user/role',
    }),
  },
  data () {
    return {
      mappedCategories: {},
      selectedCategory: null,
      selectedSub: null,
      selectedSections: [],
      presetSections: [],
      sectionsSet: new Set(),
    }
  },
  async mounted () {
    const { data } = this.role.toUpperCase() === 'ADMIN'
      ? await adminService.getAdminCategories() : await sellerService.getSellerCategories()

    this.mappedCategories = this.mapCategories(data.content)
    this.collectInitialSections(data.content)
    this.selectedCategory = this.initialCat
    this.selectedSub = this.initialSub
    this.selectedSections = this.initialSecs
    this.$emit('input', this.selectedSections, this.selectedCategory, this.selectedSub)
  },
  methods: {
    setCategory () {
      this.selectedSub = undefined
    },
    setSection (values) {
      this.selectedSections = values
      this.$emit('input', values, this.selectedCategory, this.selectedSub)
    },
    collectInitialSections(categories) {
      this.sectionsSet = new Set(this.initialSecs)
      this.presetSections = categories
        .flatMap(category => category.sub_categories)
        .flatMap(sub => Object.values(sub.sections))
        .filter(sec => this.sectionsSet.has(sec.id))
    },
    mapCategories (categories) {
      const mapped = {}

      categories.forEach(cat => {
        cat.subCategories = this.mapSubcategories(cat.sub_categories)
        mapped[cat.id] = cat
      })

      return mapped
    },
    mapSubcategories (subcategories) {
      const mapped = {}

      subcategories.forEach(cat => {
        cat.sections = this.mapSections(cat.sections)
        mapped[cat.id] = cat
      })

      return mapped
    },
    mapSections (sections) {
      const mapped = {}

      sections.forEach(cat => {
        mapped[cat.id] = cat
      })

      return mapped
    },
  },
}
</script>
